import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CardTooltipComponent } from './components/card-tooltip/card-tooltip.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialog2Component } from './components/confirmation-dialog2/confirmation-dialog2.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { TooltipDialogComponent } from './components/tooltip-dialog/tooltip-dialog.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { YearMonthPickerComponent } from './components/year-month-picker/year-month-picker.component';
import { YearPickerHeaderComponent } from './components/year-month-picker/year-picker-header/year-picker-header.component';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { DirectivesModule } from './directives.module';
import { MaterialModule } from './material.module';
import { PipesModule } from './pipes.module';
import { MatPaginatorModule  } from '@angular/material/paginator';
import { SearchResultsTableComponent } from '../search/search-results-table/search-results-table.component';
import { SearchComponent } from '../search/search.component';
import { AbandonedMineRecordComponent } from '../search/records/abandonedMines/abandoned-mine-record.component';
import { AssessmentRecordComponent } from '../search/records/assessments/assessment-record.component';
import { DrillHoleRecordComponent } from '../search/records/drillHoles/drill-hole-record.component';
import { MineralInventoryRecordComponent } from '../search/records/mineralInventory/mineral-inventory-record.component';
import { PublicationRecordComponent } from '../search/records/publications/publication-record.component';
import { AbandonedMineResultCardComponent } from '../search/results-cards/abandonedMines/abandoned-mine-result-card.component';
import { AssessmentResultCardComponent } from '../search/results-cards/assessments/assessment-result-card.component';
import { DrillHoleResultCardComponent } from '../search/results-cards/drillHoles/drill-hole-result-card.component';
import { MineralInventoryResultCardComponent } from '../search/results-cards/mineralInventory/mineral-inventory-result-card.component';
import { PublicationResultCardComponent } from '../search/results-cards/publications/publication-result-card.component';
import { WebpageAnalyticsComponent } from './components/webpage-analytics/webpage-analytics.component';
import { PublicationPdfResultCardComponent } from '../search/results-cards/publication-pdf/publication-pdf-result-card.component';
import { AssessmentPdfResultCardComponent } from '../search/results-cards/assessment-pdf/assessment-pdf-result-card.component';
import { TownshipFilter } from '../search/filters/township-filter/township-filter.component';
import { AuthorFilter } from '../search/filters/author-filter/author-filter.component';
import { NtsFilter } from '../search/filters/nts-filter/nts-filter.component';
import { SeriesFilter } from '../search/filters/series-filter/series-filter.component';
import { YearFilter } from '../search/filters/year-filter/year-filter.component';
import { CommodityFilter } from '../search/filters/commodity-filter/commodity-filter.component';
import { ResultTypeFilter } from '../search/filters/result-type-filter/result-type-filter.component';
import { DatabaseFilter } from '../search/filters/database-filter/database-filter.component';
import { CopyToClipBoardComponent } from './components/copy-to-clipboard/copy-to-clipboard.component';

@NgModule({
  declarations: [
    SearchComponent,
    TownshipFilter,
    AuthorFilter,
    NtsFilter,
    SeriesFilter,
    YearFilter,
    CommodityFilter,
    ResultTypeFilter,
    DatabaseFilter,
    SearchResultsTableComponent,
    AssessmentRecordComponent,
    AssessmentPdfResultCardComponent,
    AbandonedMineRecordComponent,
    DrillHoleRecordComponent,
    PublicationRecordComponent,
    MineralInventoryRecordComponent,
    AssessmentResultCardComponent,
    AbandonedMineResultCardComponent,
    DrillHoleResultCardComponent,
    PublicationResultCardComponent,
    PublicationPdfResultCardComponent,
    MineralInventoryResultCardComponent,
    WebpageAnalyticsComponent,
    TopNavComponent,
    FooterComponent,
    BreadcrumbsComponent,
    CopyToClipBoardComponent,
    YearPickerComponent,
    YearMonthPickerComponent,
    ConfirmationDialogComponent,
    ConfirmationDialog2Component,
    TooltipDialogComponent,
    LoadingComponent,
    ProgressSpinnerComponent,
    CardTooltipComponent,
    TooltipComponent,
    YearPickerHeaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    LayoutModule,
    PipesModule,
    DirectivesModule,
    MatPaginatorModule
  ],
  exports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    PipesModule,
    DirectivesModule,
    WebpageAnalyticsComponent,
    TopNavComponent,
    FooterComponent,
    LoadingComponent,
    ProgressSpinnerComponent,
    BreadcrumbsComponent,
    CopyToClipBoardComponent,
    YearPickerComponent,
    YearMonthPickerComponent,
    CardTooltipComponent,
    TooltipComponent
  ]
})
export class SharedModule { }
